import React, { useState, useEffect } from 'react'
import Datepicker from 'gatsby-theme-kn/src/components/technical/Datepicker'
import { useTranslation } from 'react-i18next'
import {
  apiURL,
  formatDate,
  calendarWeek,
  dateFormatter,
} from 'gatsby-theme-kn/src/utils/partner_portal_spa'
import useAxiosPartnerPortal from 'gatsby-theme-kn/src/hooks/useAxiosPartnerPortal'
import ModalModule from 'gatsby-theme-kn/src/components/modules/ModalModule'
import useModal from 'gatsby-theme-kn/src/hooks/useModal'
import ModalDebitorSearch from 'gatsby-theme-kn/src/components/modules/ModalDebitorSearch'
import ModalOrderDetail from 'gatsby-theme-kn/src/components/modules/ModalOrderDetail'
import ModalOrderStatusArchive from 'gatsby-theme-kn/src/components/modules/ModalOrderStatusArchive'
import ModalOrderConfirmationMailer from 'gatsby-theme-kn/src/components/modules/ModalOrderConfirmationMailer'
import LoadingSpinner from 'gatsby-theme-kn/src/components/modules/LoadingSpinner'

const SapServiceOrderStatus = () => {
  const { t } = useTranslation()

  const [InputData, setInputData] = useState({
    customer_number: '',
    order_type: '',
    work_order_number_from: '',
    work_order_number_to: '',
    order_number: '',
    date_from: '',
    date_to: '',
    delivery_week: '',
  })

  // Modal 2 (Debitoren-Auswahl)
  const setDebitor = function (debitor) {
    setInputData({
      ...InputData,
      customer_number: debitor,
    })
    setModalState2(false)
  }
  const [modalState2, setModalState2] = useState(false)
  const closeModal2 = () => {
    setModalState2(false)
  }

  const [Fdata, setFdata] = useState(false)
  const [partnerPortalUrl, setPartnerPortalUrl] = useState(null)
  const { data, loading, error } = useAxiosPartnerPortal(
    partnerPortalUrl,
    Fdata,
    'post'
  )

  const FormSubmit = (e) => {
    e.preventDefault()

    const d = new FormData()
    d.append('order_status[customer_number]', InputData.customer_number)
    d.append('order_status[order_type]', InputData.order_type)
    d.append(
      'order_status[work_order_number_from]',
      InputData.work_order_number_from
    )
    d.append(
      'order_status[work_order_number_to]',
      InputData.work_order_number_to
    )
    d.append('order_status[order_number]', InputData.order_number)
    d.append('order_status[date_from]', dateFormatter(InputData.date_from))
    d.append('order_status[date_to]', dateFormatter(InputData.date_to))
    d.append(
      'order_status[delivery_week]',
      dateFormatter(InputData.delivery_week)
    )

    setFdata(d)
    setPartnerPortalUrl(
      apiURL(
        'order_status?customer_number=' +
          InputData.customer_number +
          '&t=' +
          new Date().getMilliseconds()
      )
    )

    return true
  }

  // Modal: Bestell-Detail
  const [modalOrderDetailState, setModalOrderDetailState] = useState(false)
  const closeModalOrderDetail = () => {
    setModalOrderDetailState(false)
  }
  const [modalCustomerNumber, setModalCustomerNumber] = useState(false)
  const [modalWorkOrderNumber, setModalWorkOrderNumber] = useState(false)
  const [modalArchiveObject, setModalArchiveObject] = useState(false)

  const openModalOrderDetail = (customer_number, work_order_number) => {
    setModalCustomerNumber(customer_number)
    setModalWorkOrderNumber(work_order_number)
    setModalOrderDetailState(true)
  }

  // Modal: Bestell-Archiv (PDF-Download)
  const [modalOrderStatusArchiveState, setModalOrderStatusArchiveState] =
    useState(false)
  const closeModalOrderStatusArchive = () => {
    setModalOrderStatusArchiveState(false)
  }
  const openModalOrderStatusArchive = (customer_number, work_order_number) => {
    setModalCustomerNumber(customer_number)
    setModalWorkOrderNumber(work_order_number)
    setModalOrderStatusArchiveState(true)
  }

  // Modal: Bestell-Archiv Mailer
  const [
    modalOrderConfirmationMailerState,
    setModalOrderConfirmationMailerState,
  ] = useState(false)
  const closeModalOrderConfirmationMailer = () => {
    setModalOrderConfirmationMailerState(false)
  }
  const openModalOrderConfirmationMailer = (
    customer_number,
    archive_object
  ) => {
    setModalCustomerNumber(customer_number)
    setModalArchiveObject(archive_object)
    setModalOrderConfirmationMailerState(true)
  }

  const [modalTitle, setModalTitle] = useState(false)

  return (
    <>
      <ModalModule
        isOpen={modalState2}
        closeModal={closeModal2}
        title={t('generic.spa.debitor_search')}
      >
        <ModalDebitorSearch setDebitor={setDebitor} />
      </ModalModule>
      <ModalModule
        isOpen={modalOrderDetailState}
        closeModal={closeModalOrderDetail}
        title={modalTitle}
      >
        <ModalOrderDetail
          customerNumber={modalCustomerNumber}
          workOrderNumber={modalWorkOrderNumber}
          titleSetter={setModalTitle}
        />
      </ModalModule>
      <ModalModule
        isOpen={modalOrderStatusArchiveState}
        closeModal={closeModalOrderStatusArchive}
        title={`Auftragsnummer ${parseInt(modalWorkOrderNumber)}`}
      >
        <ModalOrderStatusArchive
          customerNumber={modalCustomerNumber}
          workOrderNumber={modalWorkOrderNumber}
          openModalOrderConfirmationMailer={openModalOrderConfirmationMailer}
        />
      </ModalModule>
      <ModalModule
        isOpen={modalOrderConfirmationMailerState}
        closeModal={closeModalOrderConfirmationMailer}
        title={t('generic.spa.order_confirmation_mailer.title')}
      >
        <ModalOrderConfirmationMailer
          customerNumber={modalCustomerNumber}
          archiveObject={modalArchiveObject}
          setModalOrderConfirmationMailerState={
            setModalOrderConfirmationMailerState
          }
        />
      </ModalModule>
      <div className="spa-block-full" data-spa-type="order_status">
        <form className="needs-validation">
          <div className="row">
            <div className="form-label-group col-md-6">
              <label htmlFor="customer_number">
                {t('generic.spa.customer_number')}
              </label>
              <input
                type="text"
                className="form-control"
                name="customer_number"
                required
                autoFocus
                value={InputData.customer_number}
                onChange={(e) =>
                  setInputData({
                    ...InputData,
                    customer_number: e.target.value,
                  })
                }
              />
              <div className="invalid-feedback">
                {t('generic.spa.customer_number_hint')}
              </div>
            </div>

            <div className="form-label-group col-md-6 position-relative">
              <small className="position-absolute" style={{ bottom: '0' }}>
                {t('generic.spa.customer_number_unknown') + ' '}
                <br />
                <a href="#" onClick={() => setModalState2(true)}>
                  {t('generic.spa.search_debitor')}
                </a>
              </small>
            </div>
          </div>

          <div className="form-label-group mb-1 mt-2">
            <label htmlFor="order_type">Auftragsart</label>
            <select
              id="order_type"
              className="form-select"
              name="order_type"
              defaultValue=""
              onChange={(e) =>
                setInputData({
                  ...InputData,
                  order_type: e.target.value,
                })
              }
            >
              <option value="">
                {t('generic.spa.order_status.order_type_all')}
              </option>
              <option value="1">
                {t('generic.spa.order_status.order_type.1')}
              </option>
              <option value="2">
                {t('generic.spa.order_status.order_type.2')}
              </option>
              <option value="3">
                {t('generic.spa.order_status.order_type.3')}
              </option>
              <option value="4">
                {t('generic.spa.order_status.order_type.4')}
              </option>
              <option value="5">
                {t('generic.spa.order_status.order_type.5')}
              </option>
              <option value="6">
                {t('generic.spa.order_status.order_type.6')}
              </option>
              <option value="8">
                {t('generic.spa.order_status.order_type.8')}
              </option>
              <option value="9">
                {t('generic.spa.order_status.order_type.9')}
              </option>
            </select>
          </div>

          <div className="row mb-1">
            <div className="form-label-group col-md-6">
              <label htmlFor="work_order_number_from">
                {t('generic.spa.order_status.order_number_from')}
              </label>
              <input
                type="text"
                className="form-control"
                name="work_order_number_from"
                onChange={(e) =>
                  setInputData({
                    ...InputData,
                    work_order_number_from: e.target.value,
                  })
                }
              />
            </div>

            <div className="form-label-group col-md-6">
              <label htmlFor="work_order_number_to">
                {t('generic.spa.order_status.order_number_to')}
              </label>
              <input
                type="text"
                className="form-control"
                name="work_order_number_to"
                onChange={(e) =>
                  setInputData({
                    ...InputData,
                    work_order_number_to: e.target.value,
                  })
                }
              />
            </div>
          </div>

          <div className="form-label-group mb-1">
            <label htmlFor="order_number">
              {t('generic.spa.order_status.order_number')}
            </label>
            <input
              type="text"
              className="form-control"
              name="order_number"
              onChange={(e) =>
                setInputData({
                  ...InputData,
                  order_number: e.target.value,
                })
              }
            />
          </div>

          <div className="row mb-1">
            <div className="form-label-group col-md-6">
              <label htmlFor="date_from">
                {t('generic.spa.order_status.date_from')}
              </label>
              <Datepicker
                selected={InputData.date_from}
                name="date_from"
                onChange={(date) =>
                  setInputData({
                    ...InputData,
                    date_from: date,
                  })
                }
              />
            </div>

            <div className="form-label-group col-md-6">
              <label htmlFor="date_to">
                {t('generic.spa.order_status.date_to')}
              </label>
              <Datepicker
                selected={InputData.date_to}
                name="date_to"
                onChange={(date) =>
                  setInputData({
                    ...InputData,
                    date_to: date,
                  })
                }
              />
            </div>
          </div>

          <div className="form-label-group mb-1">
            <label htmlFor="delivery_week">
              {t('generic.spa.order_status.delivery_week')}
            </label>
            <Datepicker
              selected={InputData.delivery_week}
              name="delivery_week"
              onChange={(date) =>
                setInputData({
                  ...InputData,
                  delivery_week: date,
                })
              }
            />
          </div>

          <button
            className="btn btn-primary btn-sm"
            type="submit"
            onClick={(e) => FormSubmit(e)}
          >
            {t('generic.spa.send')}
          </button>
        </form>
      </div>
      {loading && <LoadingSpinner />}

      {data && (
        <div className="spa-block-full mt-2">
          <div data-spa-result-for="order_status">
            <table className="table table-condensed table-striped">
              <thead>
                <tr>
                  {t('generic.spa.results.order_status.columns').map(
                    (col, index) => (
                      <th key={index}>{col}</th>
                    )
                  )}
                </tr>
              </thead>
              <tbody>
                {data.map((row, index) => (
                  <tr key={index}>
                    <td>
                      <>
                        <a
                          href="#"
                          data-kn-workordernumber="{row.auftragsnummer}"
                          data-kn-customernumber="{row.kundennr}"
                          data-toggle="modal"
                          data-target="#orderDetailModal"
                          onClick={() =>
                            openModalOrderDetail(
                              row.kundennr,
                              row.auftragsnummer
                            )
                          }
                        >
                          {row.auftragsnummer}
                        </a>
                        {row.pdf_flag && (
                          <a
                            href="#"
                            data-kn-workordernumber="{row.auftragsnummer}"
                            data-kn-customernumber="{row.kundennr}"
                            data-toggle="modal"
                            data-target="#orderArchiveModal"
                            onClick={() =>
                              openModalOrderStatusArchive(
                                row.kundennr,
                                row.auftragsnummer
                              )
                            }
                          >
                            &nbsp;
                            <i className="fa fa-arrow-alt-circle-right"></i>
                          </a>
                        )}
                      </>
                    </td>
                    <td>{row.submission}</td>
                    <td>{row.auftragsart}</td>
                    <td>{formatDate(row.auftragsdatum)}</td>
                    <td>
                      {row.fix_flag && formatDate(row.liefertermin)}
                      {!row.fix_flag && calendarWeek(row.liefertermin)}
                    </td>
                    <td>{row.kommission}</td>
                    <td>{row.auftragsstatus}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  )
}

export default SapServiceOrderStatus
